// extracted by mini-css-extract-plugin
export default {"imageUploadContainer":"UploadImage_imageUploadContainer__wQ7pY","uploadArea":"UploadImage_uploadArea__OJRMq"};